import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {LoadingSpinner} from '@albert-io/atomic';
import {resource} from '@albert-io/json-api-framework/request/builder';

import {getModelForResourceType} from 'resources/modelRegistry';

import {history} from 'client/history';
import sessionStore from 'client/Session/SessionStore';

import awaitMandarkQueries from 'lib/hocs/awaitMandarkQueries';

import CreateAccountsWizard from './CreateAccountsWizard/CreateAccountsWizard.react';

import './create-accounts.scss';

const CreateAccounts = ({adminUser, school, ...props}) => {
  // Redirect users whose schools don't have any domains to /school-accounts
  useEffect(() => {
    if (school.getEmailDomains().isEmpty()) {
      history.pushState(null, `/school-admin/${school.getId()}/school-accounts`);
    }
  }, [school]);

  return (
    <div className='create-accounts'>
      <CreateAccountsWizard
        coppaConsentGrantorEmail={adminUser.getEmail()}
        emailDomains={school.getEmailDomains()}
        school={school}
        {...props}
      />
    </div>
  );
};

CreateAccounts.propTypes = {
  adminUser: PropTypes.instanceOf(getModelForResourceType('user_v2')),
  params: PropTypes.object,
  school: PropTypes.instanceOf(getModelForResourceType('school_v5'))
};

export default awaitMandarkQueries(
  (props) => ({
    loadingElement: <LoadingSpinner className='u-mar-tb_4' size={2} />,
    queries: {
      school: resource('school_v5')
        .mandarkEndpoint(['schools_v5', props.params.schoolId])
        .include('email_domains_v1'),
      adminUser: resource('user_v2').mandarkEndpoint(['users_v2', sessionStore.getUserId()])
    }
  }),
  CreateAccounts
);
